export const success = state => state.success;
export const error = state => state.error;
export const resetPasswordTokenEmailSuccess = state =>
  state.resetPasswordTokenEmailSuccess;
export const resetPasswordToken = state => state.resetPasswordToken;
